import React from "react"
import GridContainer from "@/components/common/GridContainer"
import TextWrapper from "@/components/common/StructuredText/common/TextWrapper"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import { useStructuredContext } from "@/components/common/StructuredText"
import { ImageWrapper } from "@/components/common/StructuredText/components/Block"
import { getAspectRatioFromImage, getMarginsData } from "@/utils/utils"
import { colors } from "@/styles/themeSettings"
import { formatImageCMSData } from "@/components/common/Image"
import DynamicMargin from "@/components/common/DynamicMargin"

const Image = dynamic(() => import("@/components/common/Image"), {
	loading: () => <Loading />,
	ssr: false,
})

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 32,
		TABLET: 40,
		DESKTOP: 40,
	},
	BOTTOM: {
		MOBILE: 32,
		TABLET: 40,
		DESKTOP: 40,
	},
}

export default function SmallImage({ data }) {
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")
	const author = data?.image?.customData?.author || null
	const showMetaData = data?.showMetaData || false
	const aspectRatio = getAspectRatioFromImage(data?.image)
	const imageData = formatImageCMSData(data?.image)
	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<GridContainer className={`indent-desktop-${indent}`}>
				<TextWrapper className={`col-mobile-8 col-tablet-8 col-desktop-${width} no-select`}>
					<ImageWrapper $aspectRatio={aspectRatio} className={`${author ? "variant-author" : ""}`}>
						<Image
							src={imageData.url}
							alt={imageData.alt}
							showMetaData={showMetaData}
							metaData={imageData.metaData}
							metaDataColor={colors.richBlack}
							sizes="100%"
						/>
					</ImageWrapper>
					{author && <TextWrapper className={`typo-strawford typo-strawford-82 align-end italic`}>{author}</TextWrapper>}
				</TextWrapper>
			</GridContainer>
		</DynamicMargin>
	)
}
